<template>
  <div>
    <header id="site-header" class="site-header" :class="{ open: isOpen }">
      <a href="/donate">
        <div class="donate-hero mobile">
          <img src="/images/icons/heart-footer.svg" alt="" />
          {{ donateUrlTitle.title }}
        </div>
      </a>

      <div class="top-header">
        <div class="flex content-max-width">
          <!-- <ul class="desktop">
            <li v-for="(nav, index) in topNavigation" :key="index">
              <a :href="nav.url">{{ nav.title }}</a>
            </li>
          </ul> -->
          <ul class="desktop">
            <li class="dropdown">
              <a href="#">About Us<span class="caret-down"></span></a>
              <ul class="drop-links">
                <li><a href="/our-vision">Our Vision</a></li>
                <li><a href="/our-people">Our People</a></li>
                <li><a href="/history">History</a></li>
                <li><a href="/our-supporters">Our Supporters</a></li>
                <li><a href="/annual-report">Annual Report</a></li>
              </ul>
            </li>
            <!-- <li><a href="/make-a-referral">Make a Referral</a></li> -->
            <li><a href="/resources">Resources</a></li>
            <li><a href="/developers">Developers</a></li>
            <li class="dropdown">
              <a href="#">Support Us<span class="caret-down"></span></a>
              <ul class="drop-links">
                <li><a href="/volunteer">Volunteer</a></li>
                <li><a href="/donate">Donate</a></li>
                <li><a href="/other-ways-to-support-us">Other Ways to Support us</a></li>
              </ul>
            </li>
            <li><a href="/news">News</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
          <ul class="social desktop">
            <li v-for="(social, index) in socialLinks" :key="index">
              <a v-if="social.url" :href="social.url" target="_blank">
                <img :src="social.src" :alt="social.alt" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom-header">
        <div class="flex content-max-width flex-between">
          <a href="/home" class="logo">
            <img src="/images/logo.jpg" alt="test" />
          </a>

          <nav>
            <ul class="desktop">
              <li v-for="(nav, index) in desktopNavigation" :key="index">
                <a :href="nav.url">{{ nav.title }}</a>
              </li>
            </ul>
          </nav>

          <a v-if="donateUrlTitle" :href="donateUrlTitle.url" class="donate">
            <img src="/images/icons/heart-footer.svg" alt="" />
            {{ donateUrlTitle.title }}
          </a>

          <button class="hamburger mobile" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
    <div v-show="isOpen" class="mobile-menu">
      <div class="mobile-nav">
        <a href="/home" class="logo">
          <img src="/images/logo.jpg" alt="test" />
        </a>
        <button class="hamburger mobile" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <ul class="top">
        <li v-for="(nav, index) in desktopNavigation" :key="index">
          <a :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>
      <ul class="bottom">
        <li v-for="(nav, index) in topNavigation" :key="index">
          <a :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>
      <a v-if="donateUrlTitle" :href="donateUrlTitle.url" class="donate">
        <img src="/images/icons/heart-footer.svg" alt="" />{{
          donateUrlTitle.title
        }}
      </a>

      <ul class="social mobile">
        <li v-for="(social, index) in socialLinks" :key="index">
          <a :href="social.url" target="_blank">
            <img :src="social.src" :alt="social.alt" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComponent',

  props: [
    'csrf',
    'data',
    'logged_in',
    'topNavigation',
    'desktopNavigation',
    'donateUrlTitle',
    'socialLinks',
  ],
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    logout() {
      window.axios
        .post('/logout', { token: this.csrf })
        .then((response) => {
          window.location.href = '/'
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped lang="scss">
.social.mobile {
  display: flex;
  align-items: center;

  li {
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue